import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";
import { formatDate } from "@/utils/dramaUtils";

export default function NewsCard({ item }: { item: NewsItem }) {
  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex flex-col sm:flex-row gap-4 p-3 md:p-4 rounded-lg bg-background-50 border border-background-200 hover:border-accent-300 hover:bg-background-100/60 transition-colors cursor-pointer"
    >
      <div className="w-full sm:w-48 h-40 sm:h-28 shrink-0 rounded-md overflow-hidden bg-primary-900">
        <img
          src={item.cover}
          alt={`${item.title} 配图`}
          title={`${item.title} 影视资讯`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-2 text-xs">
          <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900">
            {item.category}
          </span>
          <span className="text-foreground-500">{formatDate(item.date)}</span>
        </div>
        <h3 className="text-base font-semibold text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-600 line-clamp-2 hidden sm:block">{item.summary}</p>
      </div>
    </Link>
  );
}